import { render, staticRenderFns } from "./PaginationTotalCount.vue?vue&type=template&id=2c7119a9&scoped=true&"
import script from "./PaginationTotalCount.vue?vue&type=script&lang=js&"
export * from "./PaginationTotalCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7119a9",
  null
  
)

export default component.exports